import { PortalContext } from "../../../../context/Provider";
import { GlobalContext } from "../../../../../global/context/Provider";
import React, { useContext, useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import CardTemplate from "../../../Genericos/CardTemplate/CardTemplate";
import BotonToggle from "../../../Genericos/BotonToggle/BotonToggle";
import {
  wsPatchDispositivoPreferencias,
  wsDeleteDispositivoPaciente,
  dispositivoPacientePreferenciasReset,
} from "../../../../context/Actions/dispositivoPaciente/dispositivoPaciente";
import {
  showModal,
  hideModal,
} from "../../../../context/Actions/modal/modal";
import { showToaster } from "../../../../../global/context/action/toaster/toaster";
import "./CardNotificaciones.css";

const IS_NATIVE = Capacitor.isNativePlatform();

const CardNotificaciones = ({ onClickAceptaWsp }) => {
  const {
    pacienteState,
    textosState,
    dispositivoPacienteState,
    dispositivoPacienteDispatch,
    modalDispatch,
  } = useContext(PortalContext);
  const { toasterDispatch } = useContext(GlobalContext);

  const device = dispositivoPacienteState?.dispositivoPaciente?.data;
  // El back devuelve `idApp` (camelCase). Fallback a `idapp` por si algún
  // dispatch legacy usaba minúscula.
  const deviceVinculado = !!(device?.idApp || device?.idapp);
  const [pushOn, setPushOn] = useState(device?.notificacionesActivas ?? true);

  useEffect(() => {
    setPushOn(device?.notificacionesActivas ?? true);
  }, [device?.notificacionesActivas]);

  const onTogglePush = () => {
    const nuevo = !pushOn;
    setPushOn(nuevo);
    wsPatchDispositivoPreferencias(
      { notificacionesActivas: nuevo },
      () => {
        showToaster(
          {
            texto: nuevo
              ? "Notificaciones activadas en este dispositivo"
              : "Notificaciones pausadas en este dispositivo",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
        dispositivoPacientePreferenciasReset()(dispositivoPacienteDispatch);
      }
    )(dispositivoPacienteDispatch);
  };

  const onDesvincular = () => {
    showModal(
      "Genericos/ConfirmDangerModal/ConfirmDangerModal",
      {
        titulo: "¿Desvincular este dispositivo?",
        body:
          "Vas a dejar de recibir notificaciones push en este dispositivo. Podés volver a vincularlo cerrando sesión y entrando de nuevo.",
        confirmLabel: "Sí, desvincular",
        cancelLabel: "Cancelar",
        dismiss: () => hideModal()(modalDispatch),
        onConfirm: () => {
          wsDeleteDispositivoPaciente()(dispositivoPacienteDispatch);
          hideModal()(modalDispatch);
          showToaster(
            { texto: "Dispositivo desvinculado.", tipo: "success" },
            "centroArriba"
          )(toasterDispatch);
        },
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  return (
    <React.Fragment>
      <CardTemplate
        tituloCard="Mis notificaciones"
        bodyCard={
          <div className="ptur-card-perfil-body-notificaciones">
            <div className="ptur-card-perfil-body-notificaciones-columna1-fila1">
              <h3 className="ptur-card-perfil-body-notificaciones-texto rb16t c-grey45">
                {textosState.textos.data
                  ? textosState.textos.data.txtAceptaWhatsapp.descripcion
                  : ""}
              </h3>
            </div>
            <div className="ptur-card-perfil-body-notificaciones-columna2-fila1">
              <BotonToggle
                onClickAceptaWsp={onClickAceptaWsp}
                wspVinculado={
                  pacienteState.paciente.datosActualizados.aceptaAlertaWapp
                }
                active={
                  pacienteState.paciente.datosActualizados.aceptaAlertaWapp
                }
                altStr="aceptaWsp"
              />
            </div>

            {IS_NATIVE && deviceVinculado && (
              <>
                <div className="ptur-card-perfil-body-notificaciones-columna1-fila2">
                  <h3 className="ptur-card-perfil-body-notificaciones-texto rb16t c-grey45">
                    Recibir notificaciones push en{" "}
                    <b>{device.descripcion || "este dispositivo"}</b>.
                  </h3>
                </div>
                <div className="ptur-card-perfil-body-notificaciones-columna2-fila2">
                  <BotonToggle
                    onClickAceptaWsp={onTogglePush}
                    wspVinculado={pushOn}
                    active={pushOn}
                    altStr="aceptaWsp"
                  />
                </div>

                <div className="ptur-card-perfil-desvincular-wrapper">
                  <button
                    type="button"
                    className="ptur-card-perfil-desvincular-btn"
                    onClick={onDesvincular}
                  >
                    Desvincular este dispositivo
                  </button>
                </div>
              </>
            )}
          </div>
        }
      />
    </React.Fragment>
  );
};

export default CardNotificaciones;
